module.exports = __webpack_public_path__ + "media/images/bg-callout-1d3be2750fc0090b8dce99f84b282bfa.jpg";